import React, { useState } from "react";
import "./Services.css";

const Services = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="services section" id="services">
      <h2 className="section_title">Services</h2>
      <span className="section_subtitle">What I offer</span>

      <div className="services_container container grid">
        <div className="services_content">
          <div>
            <i className="uil uil-mobile-android services_icon"></i>
            <h3 className="services_title">
              Mobile App
              <br />
              Development
            </h3>
          </div>
          <span className="services_button" onClick={() => toggleTab(1)}>
            View More
            <i className="uil uil-arrow-right services_button_icon"></i>
          </span>
          <div
            className={
              toggleState === 1
                ? "services_modal active-modal"
                : "services_modal"
            }
          >
            <div className="services_modal_content">
              <i
                className="uil uil-times services_modal_close"
                onClick={() => toggleTab(0)}
              ></i>
              <h3 className="services_model_title">Mobile App Development</h3>
              <p className="services_model_description">
                3 years of experience in mobile application development
              </p>
              <ul className="services_modal_services grid">
                <li className="services_modal_service">
                  <i className="uil uil-check-circle services_modal_icon"></i>
                  <p className="services_modal_info">
                    Develop apps for next gen users
                  </p>
                </li>

                <li className="services_modal_service">
                  <i className="uil uil-check-circle services_modal_icon"></i>
                  <p className="services_modal_info">
                    Building scalable apps with focus on usability and
                    performance
                  </p>
                </li>

                <li className="services_modal_service">
                  <i className="uil uil-check-circle services_modal_icon"></i>
                  <p className="services_modal_info">
                    Improve your existing apps and ensuring modern standards are
                    followed
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="services_content">
          <div>
            <i className="uil uil-users-alt services_icon"></i>
            <h3 className="services_title">
              1:1
              <br />
              Mentoring
            </h3>
          </div>
          <span className="services_button" onClick={() => toggleTab(2)}>
            View More
            <i className="uil uil-arrow-right services_button_icon"></i>
          </span>
          <div
            className={
              toggleState === 2
                ? "services_modal active-modal"
                : "services_modal"
            }
          >
            <div className="services_modal_content">
              <i
                className="uil uil-times services_modal_close"
                onClick={() => toggleTab(0)}
              ></i>
              <h3 className="services_model_title">Mentoring</h3>
              <p className="services_model_description">
                Help upskill you or your team in app development
              </p>
              <ul className="services_modal_services grid">
                <li className="services_modal_service">
                  <i className="uil uil-check-circle services_modal_icon"></i>
                  <p className="services_modal_info">
                    Help you setup a personalized roadmap
                  </p>
                </li>

                <li className="services_modal_service">
                  <i className="uil uil-check-circle services_modal_icon"></i>
                  <p className="services_modal_info">
                    Weekly calls to discuss progress and clarify doubts
                  </p>
                </li>

                <li className="services_modal_service">
                  <i className="uil uil-check-circle services_modal_icon"></i>
                  <p className="services_modal_info">
                    Review your code and offer suggestions on improvements
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="services_content">
          <div>
            <i className="uil uil-megaphone services_icon"></i>
            <h3 className="services_title">
              Technical
              <br />
              Speaker
            </h3>
          </div>
          <span className="services_button" onClick={() => toggleTab(3)}>
            View More
            <i className="uil uil-arrow-right services_button_icon"></i>
          </span>
          <div
            className={
              toggleState === 3
                ? "services_modal active-modal"
                : "services_modal"
            }
          >
            <div className="services_modal_content">
              <i
                className="uil uil-times services_modal_close"
                onClick={() => toggleTab(0)}
              ></i>
              <h3 className="services_model_title">Technical Speaker</h3>
              <p className="services_model_description">
                Speak at your conferences/hackathons
              </p>
              <ul className="services_modal_services grid">
                <li className="services_modal_service">
                  <i className="uil uil-check-circle services_modal_icon"></i>
                  <p className="services_modal_info">
                    Conduct workshops on app development
                  </p>
                </li>

                <li className="services_modal_service">
                  <i className="uil uil-check-circle services_modal_icon"></i>
                  <p className="services_modal_info">
                    Speak about latest trends in Android development
                  </p>
                </li>
                <li className="services_modal_service">
                  <i className="uil uil-check-circle services_modal_icon"></i>
                  <p className="services_modal_info">
                    Offer insights on building production level apps
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
